module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/camera_office-2726d23fe91057514569691dde8288e3.png";